const elements = document.querySelectorAll('*');
function prepareAlpine(prefix, directive) {
  for (let i = 0; i < elements.length; i++) {
    replaceAttributeName(elements[i], prefix, directive)
  }
  checkTemplateUpdates(prefix, directive);
}

function replaceAttributeName(element, prefix, directive){
  const attributes = element.attributes;
  for (let j = 0; j < attributes.length; j++) {
    const attributeName = attributes[j].name;
    const attributeValue = attributes[j].value;
    if (attributeName.startsWith(prefix)) {
      element.removeAttribute(attributeName);
      element.setAttribute(attributeName.replace(prefix, directive), attributeValue);
      break;
    }
  }
}

function checkTemplateUpdates(prefix, directive) {
  const templates = document.querySelectorAll("template");
  for (let i = 0; i < templates.length; i++) {
      const parent = templates[i].parentElement;
      if(parent){
          observeDOM(parent, (mutations) => {
              mutations.forEach((mutation) => {
                  mutation.target.querySelectorAll("*:not(template)").forEach((node) => {
                    replaceAttributeName(node, prefix, directive)
                  })
              });
          })
      }
  }
}
function observeDOM(element, callback){
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  if (!element || element.nodeType !== 1) return;
  if (MutationObserver) {
      let mutationObserver = new MutationObserver(callback)

      mutationObserver.observe(element, {
          childList: true,
          subtree: true
      })
  }

  else if (window.addEventListener) {
      element.addEventListener('DOMNodeInserted', callback, false)
      element.addEventListener('DOMNodeRemoved', callback, false)
  }
}

export function initAlpine(){
  prepareAlpine('data-x-data', 'x-data');
  prepareAlpine('data-x-ref', 'x-ref');
  prepareAlpine('data-x-cloak', 'x-cloak');
  prepareAlpine('data-x-show', 'x-show');
  prepareAlpine('data-x-dialog-product', 'x-on:dialog-product');
  prepareAlpine('data-x-dialog', 'x-on:dialog');
  prepareAlpine('data-x-cancel', 'x-on:cancel');
  prepareAlpine('data-x-click', 'x-on:click');
  prepareAlpine('data-x-text', 'x-text');
  prepareAlpine('data-x-bind', 'x-bind');
  prepareAlpine('data-x-class', ':class');
  /*prepareAlpine('data-x-click', 'x-on:click');
  prepareAlpine('data-x-click-outside', 'x-on:click.outside');
  prepareAlpine('data-x-mouseenter', 'x-on:mouseenter');
  prepareAlpine('data-x-mouseleave', 'x-on:mouseleave');
  prepareAlpine('data-x-class', ':class');
  prepareAlpine('data-x-change', 'x-on:change');
  prepareAlpine('data-x-show', 'x-show');
  prepareAlpine('data-x-transition', 'x-transition');
  prepareAlpine('data-x-submit', 'x-on:submit');
  prepareAlpine('data-x-cloak', 'x-cloak');
  prepareAlpine('data-x-modal', 'x-on:modal');
  prepareAlpine('data-x-for', 'x-for');
  prepareAlpine('data-x-key', ':key');
  prepareAlpine('data-x-model', 'x-model');
  prepareAlpine('data-x-text', 'x-text');
  prepareAlpine('data-x-disabled', ':disabled');
  prepareAlpine('data-x-if', 'x-if');*/
}

initAlpine();
